<template>
  <div id="home" :style="`background: url(${background}) no-repeat center center fixed;`">
    <div class="row">
      <div class="col-md-4 col-md-offset-4 col-sm-10 col-sm-offset-1 logo-container">
        <img class="img-responsive" :src="logo" alt="CapsimInbox IAP Login" />
      </div>
    </div>
    <div class="row">
      <div
        id="form"
        :class="`mat col-md-${containerGridCount} col-md-offset-${offsetGridCount} col-sm-10 col-sm-offset-1 mt-20 mb-40 p-25`"
      >
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'BaseHomePage',

    props: {
      logo: {
        type: String,
        default: '/capsiminbox/images/CapsimInbox_Logo.png',
      },
      background: {
        type: String,
        default: '/capsiminbox/images/Capsim_IAP_SignIn_Bg.png',
      },
      containerGridCount: {
        type: Number,
        default: 4,
      },
    },

    mounted() {
      $('body').addClass('home');
    },

    computed: {
      offsetGridCount() {
        return Math.floor((12 - this.containerGridCount) / 2);
      },
    },
  };
</script>
<style lang="scss" scoped>
  #form {
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 3px;
    opacity: 1;
  }
  #home {
    -webkit-background-size: cover !important;
    -moz-background-size: cover !important;
    -o-background-size: cover !important;
    background-size: cover !important;
    height: 100vh;
    overflow-x: hidden;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
  }

  .logo-container {
    display: flex;
    justify-content: center;
    img {
      width: 80%;
      margin-top: 20%;
      margin-bottom: 40px;
    }
  }
</style>
